import { useEffect } from "react";
import { motion } from "framer-motion";
import { Emblem } from "./Emblem";

export const Loader = ({ onComplete }) => {
  const reduced =
    typeof window !== "undefined" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  useEffect(() => {
    const t = setTimeout(onComplete, reduced ? 450 : 2150);
    return () => clearTimeout(t);
  }, [onComplete, reduced]);

  return (
    <motion.div
      data-testid="loading-screen"
      className="fixed inset-0 z-[150] flex flex-col items-center justify-center bg-[#030303]"
      exit={
        reduced
          ? { opacity: 0, transition: { duration: 0.35 } }
          : { opacity: 0, y: -14, transition: { duration: 0.65, ease: [0.22, 1, 0.36, 1] } }
      }
    >
      <motion.div
        className="relative"
        initial={{ opacity: 0.7, scale: 0.92, filter: "blur(10px)" }}
        animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
        transition={{ duration: 0.7, ease: "easeOut" }}
      >
        <div
          className="absolute left-1/2 top-1/2 -z-10 h-64 w-64 -translate-x-1/2 -translate-y-1/2 rounded-full"
          style={{
            background:
              "radial-gradient(circle, rgba(200,164,93,0.14) 0%, transparent 65%)",
          }}
          aria-hidden="true"
        />
        <Emblem className="h-28 w-auto" />
      </motion.div>
      <motion.div
        className="mt-8 h-px w-44 origin-center bg-gradient-to-r from-transparent via-[#C8A45D] to-transparent"
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 0.85, delay: 0.55, ease: [0.22, 1, 0.36, 1] }}
      />
      <motion.p
        className="mt-6 text-[10px] font-light uppercase tracking-[0.42em] text-champagne/80"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 1 }}
      >
        Private Concierge
      </motion.p>
    </motion.div>
  );
};
